import { useEffect } from 'react';
import i18n from 'src/i18n';

export const useUnloadBlocker = (condition = true) => {
    useEffect(() => {
        if (!condition) return;
        const block = (e: BeforeUnloadEvent) => {
            e.returnValue = i18n.t('messages.unsavedChanges');
        };
        window.addEventListener('beforeunload', block);
        return () => {
            window.removeEventListener('beforeunload', block);
        };
    }, [condition]);
};
